import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down', 'ArrowDown', [["path",{"d":"M12 4.5v15m6-5.625L12 19.5l-6-5.625","key":"svg-0"}]]);